// STY-445: session replay is limited to the AUTHENTICATED submission detail page to stay within the
// PostHog free-tier recording budget (same rationale as react-frontend STY-438) AND to keep the
// public share link out of replay. Match ONLY /submissions/submission/<id> — NOT the public
// /submissions/submission/<id>/<publicHash> link, whose hash is a reusable access credential that
// must never be captured into session replay (the recorded DOM) or analytics. (Codex P2 #85.)
// The hash is additionally redacted from event URLs by before_send in utils/posthog.js.
export const SUBMISSION_DETAIL_PATH = /^\/submissions\/submission\/\d+\/?$/

export function shouldRecordSessionPath (pathname) {
  return SUBMISSION_DETAIL_PATH.test(pathname)
}
